import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SchedulerRoutingModule } from './scheduler-routing.module';
import { ResourcePlanerComponent } from './resouce-planer/resource-planer.component';
import {SharedModule} from "../shared/shared.module";



@NgModule({
  declarations: [
    ResourcePlanerComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SchedulerRoutingModule,
  ]
})
export class ResourceSchedulerModule { }
